import { lighten, darken } from "@mui/material";
import lightOrdarkColor from "@check-light-or-dark/color";
export default {
  styleOverrides: {
     root: ({theme} : any) => ({
      alignItems: 'flex-start',
      boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.05)',
      padding: '16px',
      borderRadius: '14px',
      border:  lightOrdarkColor(theme.palette.background.default) === 'dark' ? `1px solid  ${lighten(theme.palette.background.default, 0.1)}` :  `1px solid  ${darken(theme.palette.background.default, 0.1)}` ,
      backgroundColor: lightOrdarkColor(theme.palette.background.default) === 'dark' ?  lighten(theme.palette.background.default,0.05)  :  lighten(theme.palette.background.default,0.9) }),
  },
};
